import Vue from 'vue'
import Vuex from 'vuex'
import decode from 'jwt-decode'
import users from '@app/user/store'
import permissions from '@app/permissions/store'
import settings from '@app/settings/store'
import clients from '@app/clients/store'
import payers from '@app/payers/store'
import assignors from '@app/assignors/store'
import importInvoices from '@app/import_invoices/store'
import campaigns from '@app/campaigns/store'
import invoices from '@app/invoices/store'
import assignmentRequest from '@app/assignment_request/store'
import antecipationRequest from '@app/antecipation_request/store'
import dashboard from '@app/dashboard/store'
import steps from '@app/steps/store'
import banks from '@app/banks/store'
import invoiceRequests from '@app/invoice_requests/store'
import notifications from '@app/notifications/store'
import auth from '@app/auth/store'
import followUp from '@app/follow_up/store'
import tours from '@app/tours/store'
import profile from '@app/profile/store'
import activities from '@app/activities/store'
import payerPaymentNotifications from '@app/payer_payment_notifications/store'
import payerInvoiceUpload from '@app/payer_invoice_upload/store'
import liquidationRequests from '@app/liquidation_requests/store'
import importTemplates from '@app/import_templates/store'
import tokens from '@app/tokens/store'
import operations from '@app/operations/store'
import managerInvoices from '@app/manager_invoices/store'
import switchUsers from '@app/switch_users/store'
import funds from '@app/funds/store'
import tenantRepresentatives from '@app/tenant_representatives/store'
import payerAssignors from '@app/payer_assignors/store'
import contacts from '@app/contacts/store'
import abc from '@app/abc/store'
import initialLoad from '@app/initial_load/store'
import Worker from '@/services/worker'

// payer stores

import payerAssignmentRequest from '@app/payer/assignment_requests/store'
import payerContacts from '@app/payer_contacts/store'

Vue.use(Vuex)

const modules = {
  users,
  settings,
  clients,
  payers,
  assignors,
  importInvoices,
  permissions,
  campaigns,
  invoices,
  assignmentRequest,
  antecipationRequest,
  dashboard,
  steps,
  banks,
  invoiceRequests,
  notifications,
  auth,
  followUp,
  tours,
  profile,
  activities,
  payerPaymentNotifications,
  liquidationRequests,
  importTemplates,
  tokens,
  operations,
  managerInvoices,
  switchUsers,
  funds,
  tenantRepresentatives,
  payerAssignors,
  payerAssignmentRequest,
  payerContacts,
  contacts,
  abc,
  payerInvoiceUpload,
  initialLoad
}

export default new Vuex.Store({
  modules,
  strict: process.env.NODE_ENV !== 'production',
  state: {
    token: null,
    newCurrent: null
  },
  actions: {
    setNewCurrentUser ({ commit, dispatch }, obj) {
      commit('SET_NEW_CURRENT', obj)
      dispatch('permissions/fetch')
    },
    setToken ({ commit, dispatch }, obj) {
      commit('SET_TOKEN', obj)
      dispatch('permissions/fetch')
    },
    removeToken ({ commit }) {
      commit('REMOVE_TOKEN')
    },
    removeNewCurrent ({ commit }) {
      commit('REMOVE_NEW_CURRENT')
    },
    async watchJob (context, jobID) {
      return new Promise((resolve, reject) => {
        Worker.jobStatus(jobID)
          .then((response) => {
            resolve(response)
          })
          .catch((err) => {
            reject(err)
          })
      })
    }
  },
  mutations: {
    SET_TOKEN (state, obj) {
      state.token = obj.token
    },
    REMOVE_TOKEN (state) {
      state.token = null
    },
    SET_NEW_CURRENT (state, obj) {
      state.newCurrent = obj
    },
    REMOVE_NEW_CURRENT (state) {
      state.newCurrent = null
    }
  },
  getters: {
    current_user (state) {
      const { newCurrent } = state
      if (newCurrent != null) {
        return newCurrent
      } else {
        const { token } = state
        if (token != null) {
          const decoded = decode(token)
          return decoded
        }
        return {}
      }
    },
    token (state) {
      return state.token
    },
    newCurrent (state) {
      return state.newCurrent
    },
    isAdminUser (state) {
      const { token } = state
      if (token != null) {
        const decoded = decode(token)
        return decoded.user_type === 'admin_user'
      }
      return false
    }
  }
})



// WEBPACK FOOTER //
// ./src/store/index.js